import { createFileRoute, Link } from '@tanstack/react-router'
import { NAV } from '@/app/nav'
import { useSession } from '@/app/session'
import { Card, CardContent } from '@/components/ui/card'
import { HOTKEYS } from '@/shared/domain/hotkeys'

export const Route = createFileRoute('/_app/')({ component: HubPage })

/// Точка входу зміни. Поки екрани не написані — це чесний індекс робочих місць
/// і довідка по клавішах, а не фальшивий дашборд із намальованими числами.
function HubPage() {
  const { allows } = useSession()
  const items = NAV.filter((item) => allows(item.capability))

  return (
    <div className="mx-auto grid max-w-5xl gap-6">
      <div>
        <h1 className="text-2xl font-black tracking-tight">Робоче місце</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          Каркас застосунку. Екрани підключаються поетапно: чекін і клієнти — далі каса.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <Link key={item.to} to={item.to}>
            <Card className="hover:border-ring h-full transition-colors">
              <CardContent className="flex items-center gap-3 p-4">
                <item.icon className="text-muted-foreground size-5" aria-hidden />
                <span className="font-semibold">{item.label}</span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>

      <Card>
        <CardContent className="p-4">
          <h2 className="mb-3 text-sm font-bold">Клавіатура каси</h2>
          <ul className="grid gap-1.5 sm:grid-cols-2">
            {HOTKEYS.map((hotkey) => (
              <li key={hotkey.key} className="flex items-baseline gap-2 text-sm">
                <kbd className="bg-secondary text-secondary-foreground rounded px-1.5 py-0.5 font-mono text-[11px] font-bold">
                  {hotkey.key}
                </kbd>
                <span>{hotkey.label}</span>
                <span className="text-muted-foreground ml-auto text-xs">{hotkey.note}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  )
}
